module.exports = __webpack_public_path__ + "static/assets/13011a4d93ce8f3a4635571c7f3e82bc.svg";